export const USER_MANAGEMENT_TABLE_HEADERS=[
    {
      label: 'Menu Name',
      value: 'menu_name',
      defaultChecked: true,
      checked: true
    },
    {
      label: 'Parent Name',
      value: 'parent_name',
      defaultChecked: true,
      checked: true
    }
  ]

